/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioTransferOption
 */
export interface PortfolioTransferOption {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransferOption
     */
    sourceProgram: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioTransferOption
     */
    sourcePoints?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioTransferOption
     */
    transferRatio: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioTransferOption
     */
    convertedPoints: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransferOption
     */
    transferTime: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioTransferOption
     */
    coversShortfall?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PortfolioTransferOption
     */
    effectiveCpp?: number;
}

/**
 * Check if a given object implements the PortfolioTransferOption interface.
 */
export function instanceOfPortfolioTransferOption(value: object): value is PortfolioTransferOption {
    if (!('sourceProgram' in value) || value['sourceProgram'] === undefined) return false;
    if (!('transferRatio' in value) || value['transferRatio'] === undefined) return false;
    if (!('convertedPoints' in value) || value['convertedPoints'] === undefined) return false;
    if (!('transferTime' in value) || value['transferTime'] === undefined) return false;
    return true;
}

export function PortfolioTransferOptionFromJSON(json: any): PortfolioTransferOption {
    return PortfolioTransferOptionFromJSONTyped(json, false);
}

export function PortfolioTransferOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioTransferOption {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceProgram': json['source_program'],
        'sourcePoints': json['source_points'] == null ? undefined : json['source_points'],
        'transferRatio': json['transfer_ratio'],
        'convertedPoints': json['converted_points'],
        'transferTime': json['transfer_time'],
        'coversShortfall': json['covers_shortfall'] == null ? undefined : json['covers_shortfall'],
        'effectiveCpp': json['effective_cpp'] == null ? undefined : json['effective_cpp'],
    };
}

export function PortfolioTransferOptionToJSON(json: any): PortfolioTransferOption {
    return PortfolioTransferOptionToJSONTyped(json, false);
}

export function PortfolioTransferOptionToJSONTyped(value?: PortfolioTransferOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source_program': value['sourceProgram'],
        'source_points': value['sourcePoints'],
        'transfer_ratio': value['transferRatio'],
        'converted_points': value['convertedPoints'],
        'transfer_time': value['transferTime'],
        'covers_shortfall': value['coversShortfall'],
        'effective_cpp': value['effectiveCpp'],
    };
}

